<!-- Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. -->

<!-- ticket-thumbnail.component -->

<!-- ticketStyle is a computed property that figures out the class(es)
     to apply-->
<div
	class="ticket-edit-container__header-thumbnail"
	[ngClass]="ticketStyle"
	[style.background]="parsedTicketColor"
>
	<!-- Add a checkmark if complete -->
	<img
		*ngIf="isComplete"
		[ngClass]="{ 'ticket-edit-container_header_thumbnail-milestone': ticketType === 'milestone' }"
		[class]="predecessorPreview ? 'checkmark-small' : 'checkmark'"
		src="assets/images/check.svg"
		alt="completed check"
	/>
	<!-- Add a play icon if started -->
	<div
		*ngIf="isStarted && !isComplete"
		[ngClass]="{ 'ticket-started-icon-dark': hasDarkColor, 'ticket-started-icon-light': !hasDarkColor }"
	>
		<i class="material-icons">play_arrow</i>
	</div>

	<!-- Add a question mark if pending acceptance -->
	<div *ngIf="isAssigned" [style.background]="assignedColor" class="constraint-pending-acceptance-icon">
		<i class="material-icons">question_mark</i>
	</div>
</div>
